import Header from "../components/core/Header";
import usePageMeta from '../utils/usePageMeta';
import pagesSeo from '../data/pagesSeo.json';
import Footer from "../components/core/Footer";
import styles from "./ContactPage.module.css";
import typography from '../theme/typography';
import colors from '../theme/colors';

const ContactPage = () => {
  usePageMeta(pagesSeo.contact);
  return (
    <div className={styles.page}>
      <Header />

      <section className={styles.contactSection}>
        <div className={styles.container}>
          <h1 className={`${styles.pageTitle} page-primary-title`} style={{ ...typography.heading.large, color: colors.dark }}>
            CONTACT
          </h1>
          <hr className={styles.divider} />

          <h2 className={styles.labName} style={{ ...typography.heading.xsmall, color: colors.dark }}>
            MIT Data to AI Lab
          </h2>

          <div className={styles.contentRow}>
            <div className={styles.infoColumns}>
              <div className={styles.infoColumn}>
                <p className={styles.infoLabel} style={{ ...typography.body.large.bold, color: colors.dark }}>
                  Email
                </p>
                <a
                  href="mailto:dailabmit@gmail.com"
                  className={styles.emailLink}
                  style={{ ...typography.body.large.regular, color: colors.dark }}
                >
                  dailabmit@gmail.com
                </a>
              </div>

              <div className={styles.infoColumn}>
                <p className={styles.infoLabel} style={{ ...typography.body.large.bold, color: colors.dark }}>
                  Address
                </p>
                <address className={styles.address} style={{ ...typography.body.large.regular, color: colors.dark }}>
                  MIT Stata Center<br />
                  32 Vassar St, Room 32-D560<br />
                  Cambridge, MA 02139
                </address>
              </div>
            </div>

            <div className={styles.mapWrapper}>
              <iframe
                title="MIT Data to AI Lab Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2948.163636856!2d-71.09218!3d42.36156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e370a8b0f310c5%3A0x5fd9e8db54804e32!2s32%20Vassar%20St%2C%20Cambridge%2C%20MA%2002139!5e0!3m2!1sen!2sus!4v1"
                className={styles.map}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
